enum TrackingEvent {
  PAGE_VIEW = 'page_viewed',
}

export default TrackingEvent;
